// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'

import EmployerAccountsList from 'syft-acp-core/entities/EmployerDetail/EmployerAccountsList'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

const EmployerAccountsListView = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <PageTitle title={['Accounts', recordLabel('Employer', params.id, employerName)]}>
      <div className="page entity-list">
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        <EmployerAccountsList
          employerID={Number(params.id)}
          urlBase={`/entity/employers/view/${params.id}/accounts/view/`}
        />
      </div>
    </PageTitle>
  )
}

EmployerAccountsListView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerAccountsListView
